<template>
  <div class="jntHome">
    <div class="search1">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          v-for="(item, index) in this.$store.getters.banner[this.$route.path]"
          :key="index"
        >
          <img :src="item" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="marquee1 clearfix">
      <van-swipe style="height: 2.5rem;" vertical :autoplay="2000">
        <van-swipe-item v-for="(item, index) in candleList" :key="index">
          <div class="userList">
            <img class="marquee1-img" :src="$properties(item.myProfile, 'headImgUrl')" alt="" />
            <span class="marquee1-name">{{ $properties(item.myProfile, 'nickname') }}</span>
            <span class="marquee1txt">点亮了蜡烛</span
            ><span class="marquee1t">{{ fmtCandleDate(item.createDate) }}</span>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="creat-wrap">
      <div @click="goto('/jnt/create')" class="creat-bg">
        <div class="creat-left">
          <div class="left-title">免费创建纪念馆</div>
          <div class="left-text"><span class="mar">传递思念</span>永久保存</div>
        </div>
        <div class="creat-right">快速创建</div>
      </div>
    </div>
    <div class="creat-wrap">
      <div class="myTomb">
        <i class="tomb-icon-bg"></i>
        <div class="tomb-head flex flex_center">
          <div class="tomb-head-num">我创建的馆（{{ myhallCount }}）</div>
          <div class="tomb-head-more icon-r-more" @click="goto1">查看更多</div>
        </div>
        <div
          class="tomb-content inlineLazyImg flex"
          @click="gotoJnt(item.category, item.id)"
          v-for="(item, index) in myhallList"
          :key="index"
        >
          <div class="tomb-con-img">
            <!-- <img class="img-cover" src="../../assets/jnt/default.png" /> -->
            <img class="img-cover" :src="item.firstPhoto" />
          </div>
          <div class="tomb-con-right">
            <div style="display: flex;">
              <div class="name TextChangeToOneLines" v-if="item.hallCount.value == '2'">
                {{ item.firstName }}<i class="icon-heart-love"></i>{{ item.secondName }}
              </div>
              <div class="name TextChangeToOneLines" v-if="item.hallCount.value == '1'">
                {{ item.firstName }}
              </div>
              <div class="tomb-icon-upgrade"></div>
            </div>
            <p class="birth">{{ fmtHallBirth(item.firstBirthDate, item.firstDeathDate) }}</p>
            <p class="tips">{{ fmtHallDeath(item.firstDeathDate) }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="tjDiv">
      <div class="tjContent">
        <div class="nav-table">
          <div @click="mourn('mingren')" :class="tuijianFlag ? 'navitem active' : 'navitem'">
            推荐馆
          </div>
          <div @click="mourn('siren')" :class="!tuijianFlag ? 'navitem active' : 'navitem'">
            私人馆
          </div>
        </div>
        <div v-if="tuijianFlag" class="us-item" style="margin-bottom: 0.6rem;">
          <template v-for="(item, index) in tuijianList">
            <div @click="gotoJnt(item.category, item.id)" class="item-a" :key="index">
              <div class="item-a-box">
                <div class="item-img">
                  <div class="lazyload-wrapper ">
                    <img :src="item.firstPhoto" />
                  </div>
                </div>
                <div class="item-desc">
                  <div class="title text3">
                    {{ item.title }}
                  </div>
                  <div class="intro text4">
                    {{ item.subtitle }}
                  </div>
                  <div class="hot1">
                    <div class="hot1-counts">
                      <span class="hot1"
                        ><i class="icon-hot1"></i><span>{{ item.browserCount }}</span></span
                      ><span class="view"
                        ><i class="icon-view"></i><span>{{ item.candleCount }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div v-else class="us-item" style="margin-bottom: 0.6rem;">
          <template v-for="(item, index) in sirenList">
            <div @click="gotoJnt(item.category, item.id)" class="item-a" :key="index">
              <div class="item-a-box">
                <div class="item-img">
                  <div class="lazyload-wrapper ">
                    <img :src="item.firstPhoto" />
                  </div>
                </div>
                <div class="item-desc">
                  <div class="title text3">
                    {{ item.title }}
                  </div>
                  <div class="intro text4">
                    {{ item.subtitle }}
                  </div>
                  <div class="hot1">
                    <div class="hot1-counts">
                      <span class="hot1"
                        ><i class="icon-hot1"></i><span>{{ item.browserCount }}</span></span
                      ><span class="view"
                        ><i class="icon-view"></i><span>{{ item.candleCount }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div @click="more" class="us-more">更多推荐馆</div>
      </div>
    </div>
    <div class="jiri-warp">
      <div class="jiri-box">
        <div class="title-box">
          <span class="title">今日生祭</span
          ><span @click="jiri" class="more icon-r-more">更多纪念馆</span>
        </div>
        <div class="list-wrap">
          <template v-for="(item, index) in deathList">
            <div @click="gotoJnt(item.category, item.id)" class="list-item flex" :key="index">
              <div class="list-img">
                <div class="lazyload-wrapper ">
                  <img src="../../assets/jnt/nanjing.png" />
                </div>
              </div>
              <div class="list-right">
                <div style="display: flex;">
                  <span class="name text4">{{ item.title }}</span
                  ><span class="death special">忌日</span>
                </div>
                <p class="sr">{{ item.subtitle }}</p>
                <p class="time">{{ item.content }}</p>
                <div class="listbottom">
                  <span class="hot"
                    ><i class="icon-hot1"></i><span>{{ item.browserCount }}</span></span
                  ><span class="views"
                    ><i class="icon-view"></i><span>{{ item.candleCount }}</span></span
                  >
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="me-wrap">
      <div class="me-box">
        <div class="title">纪念馆留言</div>
        <div class="list-wrap">
          <div class="list-item clearfix" v-for="(item, index) in messageList" :key="index">
            <img
              class="user-img"
              v-if="$properties(item.myProfile, 'headImgUrl') != null"
              :src="$properties(item.myProfile, 'headImgUrl')"
              alt=""
            />
            <img class="user-img" v-else src="../../assets/jnt/user.png" alt="" />
            <div class="item-right">
              <div class="flex-top">
                <div class="nickname">{{ $properties(item.myProfile, 'nickname') }}</div>
                <div class="time">{{ fmtMessageDate(item.createDate) }}</div>
              </div>
              <div class="text text3">
                {{ item.content }}
              </div>
              <!-- <div class="us-name">
                <div class="us-icon">
                  <img src="../../assets/jnt/user.png" alt="" />
                </div>
                <div @click="gotoJnt('123')" class="name icon-r-arrow">【**纪念馆</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'jiniantang',
  data() {
    return {
      tuijianFlag: true,
      myhallCount: 0,
      myhallList: [],
      tuijianList: [],
      sirenList: [],
      deathList: [],
      messageList: [],
      candleList: [],
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    goto1() {
      this.$router.push({ path: '/jnt/center/creat' })
    },
    mourn(str) {
      if (str == 'mingren') {
        this.tuijianFlag = true
      } else {
        this.tuijianFlag = false
      }
    },
    more() {
      if (this.tuijianFlag) {
        this.$router.push({ path: '/jnt/list/tuijian' })
      } else {
        this.$router.push({ path: '/jnt/list/siren' })
      }
    },
    jiri() {
      this.$router.push({ path: '/jnt/list/jiri' })
    },
    gotoJnt(type, id) {
      var category = id
      if (type) {
        category = type.value
      }
      this.$router.push({ path: '/jnt/detail/' + category + '/' + id })
    },
    queryHallByProfile() {
      var that = this
      this.$query('/api/hall/queryHallByProfile', { myId: this.$store.getters.userId }, function(
        res
      ) {
        that.$fill(that.myhallList, res['data'])
        that.myhallCount = res.total
      })
    },
    queryTuijianPage() {
      var that = this
      this.$queryAll(
        'HallInfo',
        { recommend: '1', size: 10, sort: { orderNum: 1 } },
        ['id,category,firstPhoto,title,subtitle,browserCount,candleCount'],
        function(res) {
          that.$fill(that.tuijianList, res['data'])
        }
      )
    },
    querySirenPage() {
      var that = this
      this.$queryAll(
        'HallInfo',
        { category: 'siren', size: 10, sort: { orderNum: 1 } },
        ['id,category,firstPhoto,title,subtitle,browserCount,candleCount'],
        function(res) {
          that.$fill(that.sirenList, res['data'])
        }
      )
    },
    queryDeathPage() {
      var that = this
      this.$queryAll('/api/hall/queryHallByDeath', function(res) {
        that.$fill(that.deathList, res['data'])
      })
    },
    queryMessage() {
      var that = this
      this.$queryAll(
        'HallMessage',
        { accessType: 'public', size: 3, sort: { createDate: 0 } },
        ['id,content,createDate,myProfile.id,myProfile.nickname,myProfile.headImgUrl'],
        function(res) {
          that.$fill(that.messageList, res['data'])
        }
      )
    },
    queryCandle() {
      var that = this
      this.$queryAll(
        'HallHistory',
        {
          sourceType: 'hall',
          sourceSubtype: 'candle',
          'hallInfo.id': 'isnotnull',
          'myProfile.id': 'isnotnull',
          size: 10,
          sort: { createDate: 0 },
        },
        ['id,createDate,myProfile.nickname,myProfile.headImgUrl'],
        function(res) {
          that.$fill(that.candleList, res['data'])
        }
      )
    },
    fmtMessageDate(createDate) {
      var ret = ''
      if (createDate) {
        ret = createDate.substr(0, 10)
        if (ret == moment(new Date()).format('YYYY-MM-DD')) {
          return createDate.substr(11)
        }
      }
      return ret
    },
    fmtHallBirth(birthDate, deathDate) {
      var result = ''
      if (birthDate) {
        result = result + moment(birthDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日')
      }
      if (deathDate) {
        result = result + '-' + moment(deathDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日')
      }
      return result
    },
    fmtHallDeath(deathDate) {
      var startDate = moment(deathDate, 'YYYY-MM-DD HH:mm:ss')
      var endDate = moment(new Date())
      var years = endDate.diff(startDate, 'year')
      var days = endDate.diff(startDate.add(years, 'years'), 'day')
      return 'TA已经离开我们' + years + '年' + days + '天'
    },
    fmtCandleDate(createDate) {
      if (createDate) {
        if (
          moment(createDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD') !=
          moment(new Date(), 'YYYY-MM-DD')
        ) {
          return moment(createDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD HH:mm')
        } else {
          var totalMinute =
            moment(new Date()).diff(moment(createDate, 'YYYY-MM-DD HH:mm:ss')) / (1000 * 60)
          var hours = Math.floor(totalMinute / 60)
          var minute = totalMinute % 60
          var result = ''
          if (hours > 0) {
            result = result + hours + '小时'
          }
          if (minute > 0) {
            result = result + minute + '分钟'
          }
          if (!result) {
            result = '1分钟内'
          }
          return result
        }
      } else {
        return ''
      }
    },
  },
  mounted() {
    this.queryHallByProfile()
    this.queryTuijianPage()
    this.querySirenPage()
    this.queryDeathPage()
    this.queryMessage()
    this.queryCandle()
  },
  created() {},
}
</script>

<style>
.jnt .content {
  background-color: rgb(247, 247, 247);
  background-image: url('../../assets/jnt/topbg-chun.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  height: 18.727rem;
  width: 100%;
}
.jnt .search1 {
  height: auto;
  overflow: hidden;
  position: relative;
  padding: 0 1.363rem;
}
.jnt .search1 img {
  width: 100%;
  border-radius: 5px;
}
.searchDiv {
  position: relative;
  padding: 8px 15px;
  padding-top: 10px;
  display: flex;
  display: -webkit-flex;
  box-sizing: border-box;
}
.searchDiv .search1 {
  width: 100%;
  background: #f8f8f8;
  line-height: 3.2rem;
  border-radius: 20px;
  text-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
}
.flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.contentDiv .menuDiv {
  margin-top: 0;
}
.contentDiv .menuDiv .us-nav {
  background: transparent;
}
.menuDiv .us-nav {
  list-style: none;
  font-size: 1.4rem;
  padding: 0.685rem;
  background: #fff;
  overflow: hidden;
  padding-left: 0;
}
.content1 {
  margin-top: -9.5rem;
}
.contentDiv .marquee1 {
  padding: 0.45rem 1.36rem;
  box-sizing: border-box;
  line-height: 2.72rem;
  overflow: hidden;
}
.contentDiv .marquee1 .am-wingblank.am-wingblank-lg {
  margin: 0 !important;
}
.am-wingblank.am-wingblank-lg {
  margin-left: 15px;
  margin-right: 15px;
}
.am-wingblank {
  margin-left: 8px;
  margin-right: 8px;
}
.creat-wrap {
  padding: 0.45rem 1.36rem 0;
  box-sizing: border-box;
}
.creat-wrap .creat-bg {
  background: url(../../assets/jnt/top1.png);
  height: 6.181rem;
  background-size: 100% 100%;
  padding: 1.454rem 1.636rem 0;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}
.creat-wrap .creat-bg .creat-right {
  width: 8.181rem;
  height: 3.09rem;
  line-height: 3.09rem;
  text-align: center;
  font-size: 1.272rem;
  color: #fff;
  background: linear-gradient(155deg, #f8a66c, #ee711d);
  border-radius: 1.545rem;
}
.contentDiv .tjDiv {
  width: 100%;
  padding: 0 1.363rem;
  margin-bottom: 1.363rem;
  box-sizing: border-box;
}
.contentDiv .tjDiv .tjContent {
  background: #fff;
  padding: 1.818rem 0;
  box-sizing: border-box;
  border-radius: 0.681rem;
}
.contentDiv .tjDiv .tjContent .nav-table {
  display: flex;
  justify-content: space-between;
  padding: 0 8.772rem;
  box-sizing: border-box;
  padding-top: 0.1rem;
  padding-bottom: 0.5rem;
}
.contentDiv .tjDiv .tjContent .nav-table .navitem.active {
  font-size: 1.545rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333;
  position: relative;
  z-index: 99;
}
.contentDiv .tjDiv .tjContent .nav-table .navitem {
  color: #999;
  font-size: 1.545rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.contentDiv .tjDiv .tjContent .nav-table .navitem.active:after {
  content: '';
  width: 3.636rem;
  height: 0.545rem;
  background: linear-gradient(270deg, rgba(255, 154, 86, 0.82), #ff7c23);
  border-radius: 0.363rem;
  position: absolute;
  bottom: -0.2rem;
  left: 0;
  margin-left: 0.5rem;
  z-index: -1;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.contentDiv .tjDiv .tjContent .nav-table .navitem {
  color: #999;
  font-size: 1.545rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.contentDiv .tjDiv .tjContent .us-item {
  margin-bottom: 0.636rem;
}
.us-item .item-a {
  padding: 1.363rem;
  position: relative;
  text-decoration: none;
}
.us-item .item-a .item-a-box {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}
.contentDiv .tjDiv .tjContent .us-item .item-img {
  width: 8.181rem;
  height: 9.818rem;
  background-color: #d8d8d8;
  border-radius: 0.68rem;
}
.us-item .item-img,
.us-item .item-img-pray {
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}
.us-item .item-img {
  background: #f4f4f4;
  width: 9.095rem;
  height: 10.095rem;
}
.head1 .sheet-main .item-head-img img,
.us-item .item-img img {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  width: 100%;
  height: 100%;
  vertical-align: top;
  -o-object-fit: cover;
  object-fit: cover;
}
.us-item .item-img-pray img,
.us-item .item-img img {
  height: 100%;
  width: 100%;
}

.contentDiv .tjDiv .tjContent .us-more {
  font-size: 1.272rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
  text-align: center;
  position: relative;
}
.contentDiv .tjDiv .tjContent .us-more:after {
  content: '';
  background: url(../../assets/jnt/jt2.png) no-repeat;
  background-size: 100%;
  position: absolute;
  height: 0.965rem;
  width: 0.595rem;
  top: 50%;
  margin-left: 0.8rem;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.contentDiv .jiri-warp {
  width: 100%;
  padding: 0 1.363rem;
  margin-bottom: 1.363rem;
  box-sizing: border-box;
}
.contentDiv .jiri-warp .jiri-box {
  background: #fff;
  padding: 1.818rem 1.363rem 1.363rem;
  box-sizing: border-box;
  border-radius: 0.681rem;
}
.contentDiv .jiri-warp .jiri-box .title-box {
  width: 100%;
  height: 2rem;
  -webkit-align-items: center;
  align-items: center;
  display: flex;
  justify-content: space-between;
}
.contentDiv .jiri-warp .jiri-box .title-box .title {
  color: #333;
  font-size: 1.545rem;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.contentDiv .jiri-warp .jiri-box .title-box .more {
  color: #999;
  font-size: 1.181rem;
  background: #fff;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: inherit;
}
.icon-r-more {
  position: relative;
  padding-right: 1rem;
}
.more {
  font-size: 14px;
  color: #999;
  line-height: 30px;
  background: #f0f0f0;
}
.icon-r-more:after {
  content: '';
  background: url(../../assets/jnt/jt2.png) no-repeat;
  background-size: 100%;
  position: absolute;
  height: 0.965rem;
  width: 0.595rem;
  top: 50%;
  right: -0.25rem;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

element.style {
}
.contentDiv .jiri-warp .jiri-box .list-wrap .list-item {
  margin-top: 1.772rem;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
}
.jiri-warp .list-item .list-img {
  width: 8.181rem;
  height: 9.818rem;
  border-radius: 0.681rem;
  display: inline-block;
  overflow: hidden;
  position: relative;
}
.jiri-warp .list-item .list-img img {
  width: 100%;
  height: 100%;
  display: inline-block;
  border-radius: 0.681rem;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  position: absolute;
  vertical-align: top;
  -o-object-fit: cover;
  object-fit: cover;
}
.jiri-warp .list-item .list-right {
  box-sizing: border-box;
  -ms-flex-direction: column;
  -ms-flex-pack: justify;
  -webkit-flex-direction: column;
  -webkit-justify-content: space-between;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  width: calc(100% - 8.909rem);
  margin-top: 0.5rem;
}
.jiri-warp .list-item .list-right .sr {
  color: #666;
  font-size: 1.272rem;
  line-height: 1.272rem;
  margin: 0.909rem 0 0.636rem;
  font-family: PingFangSC-Regular, PingFang SC;
}
.jiri-warp .list-item .list-right .time {
  color: #666;
  font-size: 1.272rem;
  line-height: 1.272rem;
  margin-bottom: 1.181rem;
  font-family: PingFangSC-Regular, PingFang SC;
}

element.style {
}
.jiri-warp .list-item .list-right .listbottom {
  font-size: 1.09rem;
  color: #666;
}
.jiri-warp .list-item .list-right .name {
  color: #333;
  font-size: 1.454rem;
  line-height: 1.3;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
  margin-right: 0.9rem;
}
.text4,
.text3 {
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.text4 {
  -webkit-line-clamp: 1;
}
.jiri-warp .list-item .list-right .death {
  background: #999;
}
.jiri-warp .list-item .list-right .special {
  height: 1.454rem;
  line-height: 1.454rem;
  padding: 0 0.363rem;
  border-radius: 0.181rem;
  font-size: 1.09rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #fff;
  letter-spacing: 0.181rem;
}
.jiri-warp .list-item .list-right .listbottom {
  font-size: 1.09rem;
  color: #666;
}
.jiri-warp .list-item .list-right .listbottom .hot {
  margin-right: 2.272rem;
}
.jiri-warp .list-item .list-right .listbottom .hot .icon-hot1 {
  background: url(../../assets/jnt/hot.png) no-repeat;
  background-size: 100% 100%;
}
.jiri-warp .list-item .list-right .listbottom .hot .icon-hot1,
.jiri-warp .list-item .list-right .listbottom .views .icon-view {
  width: 20px;
  height: 20px;
  display: inline-block;
  margin-right: 0.181rem;
  position: relative;
  top: -0.15rem;
}
.jiri-warp .list-item .list-right .listbottom .views .icon-view {
  background: url(../../assets/jnt/view.png) no-repeat;
  background-size: 100% 100%;
}
.contentDiv .me-wrap {
  width: 100%;
  padding: 0 1.363rem;
  margin-bottom: 1.363rem;
  box-sizing: border-box;
}
.contentDiv .me-wrap .me-box {
  background: #fff;
  padding: 1.818rem 1.363rem 1.363rem;
  box-sizing: border-box;
  border-radius: 0.681rem;
}
.contentDiv .me-wrap .me-box .title {
  margin-bottom: 0.454rem;
  color: #333;
  font-size: 1.454rem;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
}
.contentDiv .me-wrap .me-box .list-wrap .list-item {
  margin-top: 2.272rem;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  font-family: PingFangSC-Regular, PingFang SC;
}
.me-wrap .list-item .user-img {
  width: 3.454rem;
  height: 3.454rem;
  border-radius: 50%;
  float: left;
  margin-right: 1rem;
}
.clearfix:after {
  clear: both;
  content: '';
  overflow: hidden;
  height: 0;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.me-wrap .list-item .item-right {
  box-sizing: border-box;
  overflow: hidden;
  font-size: 1.272rem;
}
.me-wrap .list-item .item-right .flex-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}
.me-wrap .list-item .item-right .flex-top .nickname,
.me-wrap .list-item .item-right .flex-top .time {
  color: #999;
}
.me-wrap .list-item .item-right .flex-top .nickname,
.me-wrap .list-item .item-right .flex-top .time {
  color: #999;
}
.me-wrap .list-item .item-right .text {
  width: 100%;
  color: #333;
  line-height: 1.909rem;
}
.text3 {
  -webkit-line-clamp: 2;
}
.text4,
.text3 {
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.me-wrap .list-item .item-right .us-name {
  margin-top: 1rem;
  overflow: hidden;
  display: inline-block;
}
.me-wrap .list-item .item-right .us-name .us-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  background: #e4803c;
  padding: 1px;
  border-top-left-radius: 2px;
  -webkit-border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  -webkit-border-bottom-left-radius: 2px;
}
.me-wrap .list-item .item-right .us-name .us-icon img {
  width: 1.181rem;
  height: 1.181rem;
  display: inline-block;
}
.me-wrap .list-item .item-right .us-name .icon-r-arrow {
  position: relative;
  padding-right: 1.5rem;
}
.me-wrap .list-item .item-right .us-name .name {
  display: inline-block;
  height: 1.818rem;
  font-size: 1.09rem;
  line-height: 2rem;
  text-align: center;
  background: rgba(228, 128, 60, 0.15);
  color: #e4803c;
  padding: 1px 2.665rem 1px 0.665rem;
  white-space: nowrap;
  text-overflow: ellipsis;
  border: 1px solid #e4803c69;
  border-left: none;
  max-width: 18rem;
  overflow: hidden;
  border-top-right-radius: 2px;
  -webkit-border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  -webkit-border-bottom-right-radius: 2px;
}
.me-wrap .list-item .item-right .us-name .icon-r-arrow:after {
  content: '';
  background: url(../../assets/jnt/jt.png) no-repeat;
  background-size: 100%;
  position: absolute;
  top: 0.65rem;
  right: 0.565rem;
  height: 0.755rem;
  width: 0.425rem;
}
*,
:after,
:before {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.us-item .item-desc .intro {
  color: #666;
  font-size: 1.2rem;
  line-height: 22px;
  margin-top: -3px;
}
.text4,
.text3 {
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-box-orient: vertical;
  word-break: break-all;
}
.text4 {
  -webkit-line-clamp: 1;
}
.us-item .item-desc {
  -ms-flex-direction: column;
  -ms-flex-pack: justify;
  -webkit-flex-direction: column;
  -webkit-justify-content: space-between;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: 10px;
  width: calc(100% - 8.909rem);
  margin-top: 0.5rem;
}
.us-item .item-desc .hot1 .hot1-counts .icon-hot1 {
  height: 20px;
  width: 20px;
  background: url(../../assets/jnt/hot.png) no-repeat;
  position: relative;
  background-size: 100% 100%;
  margin-right: 2px;
}
.us-item .item-desc .hot1 .hot1-counts .icon-view {
  height: 20px;
  width: 20px;
  background: url(../../assets/jnt/view.png) no-repeat;
  background-size: 100% 100%;
  margin-right: 2px;
  position: relative;
  top: 1px;
}
.us-item .item-desc .hot1 .hot1-counts {
  color: #666;
  font-size: 1.2rem;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}

.contentDiv .tjDiv .tjContent .us-item .item-desc .hot1 .hot1-counts .hot1 {
  margin-right: 2.272rem;
}
.us-item .item-desc .hot1 .hot1-counts .hot1,
.us-item .item-desc .hot1 .hot1-counts .view {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -ms-flex-align: center;
  -ms-flex-pack: center;
  -webkit-align-items: center;
  -webkit-justify-content: center;
  align-items: center;
}
.us-item .item-desc .hot1 {
  -ms-flex-align: end;
  -ms-flex-pack: justify;
  -webkit-align-items: flex-end;
  -webkit-justify-content: space-between;
  align-items: flex-end;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}

.marquee1-img {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: inline-block;
}
.marquee1-img {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  display: inline-block;
}
.marquee1txt {
  font-size: 1.18rem;
  color: #999;
}
.marquee1t {
  font-size: 1.18rem;
  color: #999;
  float: right;
}
.jntHome .van-swipe__indicator--active {
  background-color: unset;
}
.jntHome .userList {
  display: flex;
}
.jntHome .userList span {
  display: block;
  line-height: 2rem;
  margin: 0 0.5rem;
}
.creat-wrap {
  padding: 0.45rem 12px 0;
  box-sizing: border-box;
}

.creat-wrap .creat-bg {
  background: url(../../assets/jnt/bg3.png);
  height: 6.181rem;
  background-size: 100% 100%;
  padding: 1.454rem 1.636rem 0;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
}

.creat-wrap .creat-bg .creat-left .left-title {
  color: #944e1e;
  font-size: 1.545rem;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  letter-spacing: 0.272rem;
  margin-bottom: 0.727rem;
}

.creat-wrap .creat-bg .creat-left .left-text {
  font-size: 1.181rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #c77237;
}

.creat-wrap .creat-bg .creat-left .left-text .mar {
  margin-right: 1.363rem;
  display: inline-block;
}

.creat-wrap .creat-bg .creat-right {
  width: 8.181rem;
  height: 3.09rem;
  line-height: 3.09rem;
  text-align: center;
  font-size: 1.272rem;
  color: #fff;
  background: linear-gradient(155deg, #f8a66c, #ee711d);
  border-radius: 1.545rem;
}

.creat-wrap .myTomb {
  width: 100%;
  height: auto;
  background: #fff;
  border-radius: 0.68rem;
  box-shadow: 0 0 2.363rem 0.363rem hsla(0, 0%, 40%, 0.1);
  padding: 1.363rem 1.363rem 0;
  box-sizing: border-box;
  position: relative;
}

.creat-wrap .tomb-icon-bg {
  width: 12rem;
  height: 4rem;
  background: url(../../assets/jnt/bg2.png) no-repeat;
  background-size: 100% 100%;
  position: absolute;
  left: 0;
  top: 0;
}

.creat-wrap .myTomb .tomb-head {
  display: flex;
  justify-content: space-between;
  padding-bottom: 1.09rem;
  box-sizing: border-box;
}

.creat-wrap .myTomb .tomb-head .tomb-head-num {
  color: #e4803c;
  font-size: 1.545rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}

.creat-wrap .myTomb .tomb-head .tomb-head-more {
  color: #999;
  font-size: 1.272rem;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: inherit;
}

.creat-wrap .myTomb .tomb-content {
  border-top: 1px solid #ececec;
  padding-top: 1.363rem;
  padding-bottom: 1.363rem;
  box-sizing: border-box;
}

.creat-wrap .myTomb .bottom-line {
  position: relative;
}

.creat-wrap .myTomb .bottom-line:after {
  content: '';
  border-bottom: 1px solid #ececec;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.creat-wrap .myTomb .tomb-content .tomb-con-img {
  width: 6.363rem;
  height: 7.909rem;
  display: inline-block;
  margin-right: 1rem;
  border: 3px solid #666;
  padding: 0.15rem;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
}

.creat-wrap .myTomb .tomb-content .tomb-con-img .img-cover {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;
  width: 95%;
  height: 96%;
  vertical-align: top;
  -o-object-fit: cover;
  object-fit: cover;
}

.creat-wrap .myTomb .tomb-content .tomb-con-right {
  height: 7.909rem;
  overflow: hidden;
  display: inline-flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  box-sizing: border-box;
  width: calc(100% - 6.363rem);
}

.creat-wrap .myTomb .tomb-content .tomb-con-right .tomb-icon-upgrade {
  width: 5rem;
  height: 1.64rem;
}

.creat-wrap .myTomb .tomb-content .tomb-con-right .tomb-icon-upgrade img {
  width: 100%;
}

.creat-wrap .myTomb .tomb-content .tomb-con-right .name {
  color: #333;
  font-size: 1.454rem;
  font-weight: 500;
  font-family: PingFangSC-Medium, PingFang SC;
  line-height: 1.3;
  width: 20rem;
  padding-right: 0.9rem;
  box-sizing: border-box;
}

.creat-wrap .myTomb .tomb-content .tomb-con-right .birth {
  color: #333;
  font-size: 1.181rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.creat-wrap .myTomb .tomb-content .tomb-con-right .tips {
  color: #999;
  font-size: 1.09rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.creat-wrap .myTomb .tomb-bottom {
  margin-top: 0.9rem;
  padding-bottom: 0.9rem;
}

.creat-wrap .myTomb .tomb-bottom .bell {
  width: 1.363rem;
  height: 1.363rem;
  display: inline-block;
  margin-right: 0.636rem;
}

.creat-wrap .myTomb .tomb-bottom .text {
  color: #333;
  font-size: 1.181rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.icon-heart-love {
  width: 1.45rem;
  height: 1.45rem;
  background: url(../../assets/jnt/aixin.png) no-repeat;
  background-size: 100% 100%;
  display: inline-block;
  margin: 0 6px;
  position: relative;
  bottom: 2px;
}
</style>
